import React from 'react';
import { Star, MessageSquare, ThumbsUp, AlertCircle } from 'lucide-react';

const reviews = [
  {
    id: 1,
    customer: 'John Doe',
    product: 'Classic Sneakers',
    rating: 5,
    comment: 'Excellent quality and very comfortable. Highly recommended!',
    date: '2025-04-15',
    status: 'Published',
  },
  {
    id: 2,
    customer: 'Jane Smith',
    product: 'Elegant Heels',
    rating: 4,
    comment: 'Beautiful shoes, but took a while to break in.',
    date: '2025-04-14',
    status: 'Published',
  },
  {
    id: 3,
    customer: 'Mike Johnson',
    product: 'Military Cargo Pants',
    rating: 5,
    comment: 'Perfect fit and great quality material.',
    date: '2025-04-13',
    status: 'Pending',
  },
];

export default function Reviews() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Reviews Management</h2>

      {/* Review Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-yellow-100 p-3 rounded-lg">
              <Star className="h-6 w-6 text-yellow-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Average Rating</p>
              <p className="text-2xl font-bold">4.8</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <MessageSquare className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Total Reviews</p>
              <p className="text-2xl font-bold">256</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <ThumbsUp className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Positive Reviews</p>
              <p className="text-2xl font-bold">92%</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-orange-100 p-3 rounded-lg">
              <AlertCircle className="h-6 w-6 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Pending Reviews</p>
              <p className="text-2xl font-bold">12</p>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold">Recent Reviews</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50">
                <th className="text-left py-3 px-4">Customer</th>
                <th className="text-left py-3 px-4">Product</th>
                <th className="text-left py-3 px-4">Rating</th>
                <th className="text-left py-3 px-4">Comment</th>
                <th className="text-left py-3 px-4">Date</th>
                <th className="text-left py-3 px-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map((review) => (
                <tr key={review.id} className="border-t border-gray-200">
                  <td className="py-3 px-4 font-medium">{review.customer}</td>
                  <td className="py-3 px-4">{review.product}</td>
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-1">
                      <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                      <span>{review.rating}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4">{review.comment}</td>
                  <td className="py-3 px-4">{review.date}</td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 rounded-full text-sm ${
                      review.status === 'Published'
                        ? 'bg-green-100 text-green-700'
                        : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {review.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}